import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import IntegrationTableIvy from "../../../features/plugins/integrations/components/IntegrationTable/IntegrationTableIvy";
import IntegrationTableWorksheet from "../../../features/plugins/integrations/components/IntegrationTable/IntegrationTableWorksheet";
import IntegrationTableMcp from "../../../features/plugins/integrations/components/IntegrationTable/IntegrationTableMcp";
import SliderTab from '/src/components/slider/sliderTab';
import { PageTable, Header } from '/src/layouts/page';

function IntegrationList() {
    const [searchParams] = useSearchParams();
    const searchKey = searchParams.get('key') || undefined;
    const [activeIndex, setActiveIndex] = useState(undefined);

    const items = [
        { name: 'Ivy', component: <IntegrationTableIvy searchKey={searchKey} onKeyFound={() => setActiveIndex(0)} /> },
        { name: 'Worksheet', component: <IntegrationTableWorksheet searchKey={searchKey} onKeyFound={() => setActiveIndex(1)} /> },
        { name: 'MCP API', component: <IntegrationTableMcp /> },
    ]


    return (
        <PageTable>

            <Header title="API Key Manager"></Header>
            <SliderTab items={items} name="datasets" activeIndex={activeIndex}></SliderTab>
        </PageTable>
    )
}

export default IntegrationList;